<!-- 面包屑 -->
<template>
  <div class="BreadCrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        {{breadcrumbList[0].function_name}}
      </el-breadcrumb-item>
      <el-breadcrumb-item
        v-for="(item, index) in breadcrumbList"
        :key="index"
        :index="index"
        :to="{path: '/'+ item.function_tab}"
        v-show="(index > 0)">{{item.function_name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { 
    updataBreadCrumb,
    getBreadCrumb
  } from "@/../static/js/utility/utility.js"

  export default {
    name: 'CBreadCrumb',
    data() {
      return {
        breadcrumbList: []
      }
    },
    created() {
      // this.breadcrumbList = JSON.parse(sessionStorage.getItem('navBarActive'))
      // 当前页面路径
      let path = this.$route.path.split('/')[1]
      let breadcrumbList = getBreadCrumb()
      let length = breadcrumbList.length
      // 出现二级以上
      if (length > 2) {
        let activeI
        // 当选中的tab不是第一个或最后一个，删除后面多余的内容
        for(let i = 1; i < length - 1; i++) {
          // console.log('i', i)
          if ( breadcrumbList[i].function_tab === path) {
            // console.log('breadcrumbList[i].function_tab', breadcrumbList[i].type, 'path', path)
            // console.log('i', i)
            // 当前选中的index
            activeI = i
          } 
        }
        // 需删除的长度
        let num = length - activeI
        // 删除当前tab后面的tab
        breadcrumbList.splice(activeI + 1, num)
      }
      this.breadcrumbList = breadcrumbList
      // 更新缓存
      updataBreadCrumb(2, breadcrumbList)

      // if ( breadcrumbList[1].type === breadcrumbList[0].type) {
      //   一级列表有页面，默认显示一次tab 
      //   this.breadcrumbList = [breadcrumbList[0]]
      // } else {
      //   this.breadcrumbList = breadcrumbList
      // }
      // console.log('this.breadcrumbList', this.breadcrumbList)
    },
    mounted() {
      // console.log('面包屑', this.$store.state.navBarActive)
      if (!sessionStorage.getItem('navBarActive')) {
        return false
      }
    },
    methods: {
      // 面包屑跳转页面
    },
    watch: {
    }
  }
</script>

<style>
.mainHeadContent .breadCrumb {
    /* height: 80px; */
    
}
.el-breadcrumb__inner,.el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
  color: #fff;
}
.el-breadcrumb__item{
  color: #fff;
  /* text-decoration: underline; */
}
.el-breadcrumb__separator[class*=icon]{
  /* text-decoration: underline; */
  color: #fff;
  /* margin: 0; */
}

.mainHeadContent .breadCrumb .el-breadcrumb {
    /* height: 80px; */
    font-size: 16px;
    /* line-height: 30px; */
}
</style>



// WEBPACK FOOTER //
// src/components/Page/Layout/CBreadCrumb.vue